import { LayoutChannelsWeb } from '../../../layout/channels-web';
import { AccountContactPerson } from './form/contactPerson';
import { RenderQuestion } from './survey';
import { Grid, Typography, Paper } from '@mui/material';
import { useChannelsSurvey } from './survey/hook';
import SendIcon from '@mui/icons-material/Send';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import { useChannelWebForm } from './hook';

export const ChannelsWeb = () => {
    const { handleSubmit, setFormikContactPerson, setFormikSurvey, loading } =
        useChannelWebForm();
    const { questions, formik } = useChannelsSurvey({
        onChangeFormik: setFormikSurvey,
    });

    return (
        <>
            <LayoutChannelsWeb />
            <Grid
                container
                spacing={0}
                pt="80px"
                justifyContent="center"
                sx={{ backgroundColor: '#f8f8f8', minHeight: '100vh' }}
            >
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        padding: '40px',
                    }}
                >
                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        Apreciado Cliente
                    </Typography>

                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        Previsora Seguros te invita a actualizar los canales a
                        través de los cuales deseas ser contactado para
                        gestiones comerciales y de cobranza.
                    </Typography>

                    <Typography variant="body1" fontWeight="bold" gutterBottom>
                        DECLARACIÓN Y AUTORIZACIÓN:
                    </Typography>

                    <Typography variant="body1" paragraph>
                        Al diligenciar el presente formulario, declaro conocer y
                        estar informado que los canales de comunicación que a
                        continuación se relacionan, pueden ser utilizados por LA
                        PREVISORA SEGUROS para realizar gestiones comerciales y
                        de cobranza.
                    </Typography>

                    <Typography variant="body1">
                        En consecuencia,{' '}
                        <strong>AUTORIZO a LA PREVISORA SEGUROS</strong> y a las
                        entidades que esta delegue para la realización de
                        actividades de mercadeo y cobranza, a que me contacten a
                        través de mensajes de texto (SMS), mensajería por
                        aplicaciones web, correos electrónicos, llamadas
                        telefónicas, mensajería de correo físico, WhatsApp y
                        cualquier otro que en adelante pueda surgir.
                    </Typography>
                </Grid>

                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        padding: '40px',
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            width: '80%',
                            padding: '30px',
                            borderRadius: '10px',
                        }}
                    >
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                gutterBottom
                                sx={{ color: 'primary.main' }}
                            >
                                Manifiesto que, en caso de que no requiera ser
                                contactado por alguno de estos canales para los
                                propósitos descritos anteriormente, lo indicaré
                                a continuación:
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                gutterBottom
                                sx={{ color: 'primary.main' }}
                            >
                                En el ejercicio de esta elección, indico que no
                                quiero ser contactado por los siguientes
                                canales, (seleccione máximo 4){' '}
                            </Typography>
                        </Grid>
                        {questions.length > 0 && (
                            <RenderQuestion
                                question={questions[0]}
                                formik={formik}
                            />
                        )}
                        <Grid
                            style={{ marginBottom: '20px', marginTop: '20px' }}
                        >
                            <Typography
                                variant="body1"
                                gutterBottom
                                sx={{ color: 'primary.main' }}
                                fontWeight="bold"
                            >
                                AUTORIZA
                            </Typography>
                            <AccountContactPerson
                                onChangeFormik={(formik) =>
                                    setFormikContactPerson(formik)
                                }
                            />
                        </Grid>

                        <LoadingButtonGeneral
                            loading={loading}
                            loadingPosition="end"
                            title="Enviar"
                            endIcon={
                                <SendIcon
                                    sx={{ color: 'primary.contrastText' }}
                                />
                            }
                            sx={{ mr: 1 }}
                            onClick={handleSubmit}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
};
